(function() {
    'use strict';

    angular.module('allegro').directive('dynamicFields', dynamicFields);

    dynamicFields.$inject = [];

    function dynamicFields() {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            templateUrl: 'app/allegro/directives/dynamic-fields/dynamic-fields.html',
            scope: {
                fields: '=',
            },
            link: function(scope, element, attrs, controller) {
                scope.form = scope.$parent.form;
                scope.onFieldChange = function(field){}

                formatFieldsAttrs();

                function formatFieldsAttrs(){
                    scope.fields.forEach(function(field) {
                        var restrictions = field.restrictions;
                        if (restrictions && restrictions.precision) {
                            field.restrictions.precision = formatPrecision(restrictions.precision);
                        }
                    });
                }

                function formatPrecision(precision) {
                    if(precision){
                        return Math.pow(10, -precision);
                    }
                    return 0
                }
            }
        };
    }
})();
